"use client";

import React from 'react';
import { Button } from '@pagespeedify/ui';
import { Mail, Twitter } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@pagespeedify/ui";

interface SidebarFooterProps {
  onContactClick: () => void;
}

export const SidebarFooter: React.FC<SidebarFooterProps> = ({ onContactClick }) => {
  return (
    <div className="mt-auto p-2 flex items-center justify-center space-x-2 border-t">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              aria-label="Contact Support"
              onClick={onContactClick}
            >
              <Mail className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Contact Support</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <a
              href="https://x.com/swayashin"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background hover:bg-accent hover:text-accent-foreground h-8 w-8"
              aria-label="Follow us on Twitter"
            >
              <Twitter className="h-4 w-4" />
            </a>
          </TooltipTrigger>
          <TooltipContent>
            <p>Follow us on Twitter</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};